export const API = {
  public: {
    province: process.env.REACT_APP_API_URL_DEF + "/def/v1/ostan/list",
    cities: process.env.REACT_APP_API_URL_DEF + "/def/v1/city/list",
    measurement:
      process.env.REACT_APP_API_URL_DEF_MAIN +
      "/def/v1/measurement-unit/drop-down",
    buyerType:
      process.env.REACT_APP_API_URL_DEF_MAIN + "/def/v1/buyer-type/drop-down",
    stuff: process.env.REACT_APP_API_URL_DEF_MAIN + "/def/v1/stuff/search",
    version: process.env.REACT_APP_API_URL_DEF_MAIN + "/def/v1/app/version",
    currency:
      process.env.REACT_APP_API_URL_DEF_MAIN +
      "/def/v1/currenty-type/drop-down",
  },
  auth: {
    captch: process.env.REACT_APP_API_URL_AUTH + "/auth/v1/captcha",
    login: process.env.REACT_APP_API_URL_AUTH + "/auth/v1/login/username",
    forgetPassWord:
      process.env.REACT_APP_API_URL_AUTH + "/auth/v1/password/forgot",
    genrateOtp: process.env.REACT_APP_API_URL_AUTH + "/auth/v1/otp/generate",
    loginOtp: process.env.REACT_APP_API_URL_AUTH + "/auth/v1/login/otp",
    loginQr: process.env.REACT_APP_API_URL_AUTH + "/auth/v1/login/qr",
  },
  user: {
    register: process.env.REACT_APP_API_URL_MEM + "/mem/v1/user/register",

    registerModi:
      process.env.REACT_APP_API_URL_MEM_MAIN +
      "/mem/v1/account/user/register/tax",

    profile: process.env.REACT_APP_API_URL_MEM + "/mem/v1/user/profile",
    permissions:
      process.env.REACT_APP_API_URL_DEF_MAIN + "/mem/v1/state/drop-down",
    checkToken:
      process.env.REACT_APP_API_URL_MEM_MAIN + "/mem/v1/auth/token/check",
  },
  info: {
    /* for sell */

    productList:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/seller-stuff/list",
    productItem:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/seller-stuff/item",
    product: process.env.REACT_APP_API_URL_INFO + "/info/v1/seller-stuff",
    customer: process.env.REACT_APP_API_URL_INFO + "/info/v1/buyer/list",
    customerItem: process.env.REACT_APP_API_URL_INFO + "/info/v1/buyer/item",
    customerSingle: process.env.REACT_APP_API_URL_INFO + "/info/v1/buyer",
    sellerLast:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/seller-stuff/last",
    buyerLast: process.env.REACT_APP_API_URL_INFO + "/info/v1/buyer/last",

    buyer: process.env.REACT_APP_API_URL_INT + "/info/v1/buyer/search",
    stuff:
      process.env.REACT_APP_API_URL_INT + "/info/v1/seller-stuff/buyer/list",

    /* for buy */

    productBuyList:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/purch-stuff/list",
    productBuyItem:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/purch-stuff/item",
    productBuy: process.env.REACT_APP_API_URL_INFO + "/info/v1/purch-stuff",
    productBuyLast:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/purch-stuff/last",
    customerBuy: process.env.REACT_APP_API_URL_INFO + "/info/v1/seller/list",
    customerItemBuy:
      process.env.REACT_APP_API_URL_INFO + "/info/v1/seller/item",
    customerSingleBuy: process.env.REACT_APP_API_URL_INFO + "/info/v1/seller",
    seller: process.env.REACT_APP_API_URL_INT + "/info/v1/seller/search",
    sellersLast: process.env.REACT_APP_API_URL_INFO + "/info/v1/seller/last",
    group:
      process.env.REACT_APP_API_URL_INFO +
      "/info/v1/seller-stuff-group/drop-down",
    stuffBuy:
      process.env.REACT_APP_API_URL_INT + "/info/v1/purch-stuff/seller/list",
  },
  pub: {
    dashboardInfo: process.env.REACT_APP_API_URL_PUB + "/pub/v1/dashboard/info",
    dashboardInfoApp:
      process.env.REACT_APP_API_URL_PUB + "/pub/v1/dashboard/info/app",
    purch:
      process.env.REACT_APP_API_URL_INT + "/pub/v1/dashboard/info/app/purch",
  },
  rep: {
    sellPurch:
      process.env.REACT_APP_API_URL_REP + "/rep/v1/dash-panel/chart/sell-purch",
  },
  int: {
    default: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/default",
    list: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/list",
    item: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/item",
    single: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell",
    app: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/app",
    getData:
      process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/item/app",
    copy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/copy",
    edit: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/edit",
    cancel: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/cancel",
    send: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/send/app",
    remove: process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell",
    sendSms:
      process.env.REACT_APP_API_URL_INT + "/invoice/v1/int/sell/print/sms",
    /* ------------------------------- buy -------------------------- */
    defaultBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/default",
    listBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/list",
    itemBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/item",
    copyBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/copy",
    singleBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch",
    appBuy: process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/app",

    getDataBuy:
      process.env.REACT_APP_API_URL_INT + "/invoice/v1/purch/item/app",
  },
};
